import {
  getLoginShopid,
  getLanguage, getStorageCityId, getStorageRegion,
  getRegionByCookie,
  getLoginAccountId,
  getIsCloudUI,
  getShopIDs,
} from '@RootCommon/utils'
import { commonRequestAll, commonRequest } from '@/common/utils/request'
import mainApi, { adApi } from '@/common/api/urls'
import { ShopAndBrandInfoVoRes, DiagnosisReportExistsRes } from '@/@types'

/** IM入口展示场景：1=普通门店，2=云厨房 */
export enum ShowImMsgBoxScene {
  Normal = 1,
  CloudKitchen = 2,
}

// 获取门店列表，依赖acctId, 账号相关的i18n信息就绪
export async function getAccountShopListApi (params: {
  acctIds: string,
  shopName: string,
  pageNo: number,
  pageSize: number,
}) {
  return commonRequestAll.post(
    mainApi.getShopListByAccount,
    params,
    {
      headers: {
        locale: getLanguage(),
        region: getRegionByCookie(), // getRegion会优先从url获取值，初次加载时，账号的region还未更新到url。
        cityId: getStorageCityId(),
        // currency: getCurrency(),
      },
    }
  )
}

export async function getSettledShopListApi () {
  return commonRequest.get(
    mainApi.getSettledShopList,
    {
      headers: {
        locale: getLanguage(),
        region: getRegionByCookie(),
        opCenterSelectedRegion: getRegionByCookie(),
      },
    },
  )
}

export async function getShopCloseReason (shopId: number) {
  return commonRequest.get(
    mainApi.getShopCloseReason,
    {
      params: { shopId },
    }
  )
}

export async function getShowImMsgBoxApi (_shopId: number) {
  const isCloudUI = getIsCloudUI()
  const shopId = _shopId || getLoginShopid()
  return commonRequest.post(
    mainApi.getShowImMsgBox,
    {
      scene: isCloudUI ? ShowImMsgBoxScene.CloudKitchen : ShowImMsgBoxScene.Normal,
      ...(isCloudUI ? { subShopIdList: getShopIDs() } : { shopId }),
    },
  )
}

/** 查询是否存在有效诊断报告及是否已读（无需入参，region 由网关注入） */
export async function getDiagnosisReportExistsApi (): Promise<DiagnosisReportExistsRes> {
  return commonRequest.post(
    mainApi.diagnosisReportExists,
    {},
    { autoToast: false },
  )
}

export async function getShopAndBrandInfo ({ acctId, shopName, pageSize, pageNumber }: {
  acctId: string,
  shopName?: string,
  pageSize?: number,
  pageNumber?: number,
}): Promise<ShopAndBrandInfoVoRes> {
  return commonRequest.post(
    mainApi.getShopAndBrandInfo,
    {
      acctId,
      shopName,
      pageSize,
      pageNumber,
    },
  )
}